export default __webpack_public_path__ + "images/assets/3f4628973fc398efb3ddf95a37b6ece1.svg";